import {
  requiresAuth,
  detectActivityData,
  allowTester,
  homeUseTokenRedirect
} from 'utils/routerMiddleware';
import ActivityTester from 'views/ActivityTester';
import ComponentTester from 'views/ComponentTester';
import ActivityContainer from 'views/ActivityContainer.vue';
import KeyboardSelection from 'views/KeyboardSelection.vue';
import ActivityPreview from 'views/ActivityPreview';
import Curriculum from 'components/curriculum/curriculum';
import awardScreen from 'components/curriculum/award-screen.vue';
import spotcheckResult from 'components/curriculum/spotCheckResult';
import assessmentHelp from 'components/utils/AssessmentHelp';
import { lazyReactInVue } from 'vuereact-combined';

export default [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: lazyReactInVue(() => import('../react_app/App')),
    meta: {
      middleware: [homeUseTokenRedirect]
    }
  },
  {
    path: '/tester',
    name: 'tester',
    component: ActivityTester,
    meta: {
      title: 'ActivityTester',
      middleware: [allowTester]
    }
  },
  {
    path: '/tester/components',
    name: 'componentTester',
    component: ComponentTester,
    meta: {
      title: 'ComponentTester',
      middleware: [allowTester]
    }
  },
  {
    path: '/activities/:activityName',
    name: 'activityContainer',
    component: ActivityContainer,
    meta: {
      title: 'ActivityContainer',
      middleware: [detectActivityData]
    }
  },
  {
    path: '/keyboard-select',
    name: 'keyboardSelect',
    component: KeyboardSelection,
    meta: {
      title: 'KeyboardSelection',
      middleware: [detectActivityData]
    }
  },
  {
    path: '/component-tester-keyboard-select',
    name: 'componentTesterKeyboardSelect',
    component: KeyboardSelection,
    meta: {
      title: 'KeyboardSelection'
    }
  },
  {
    path: '/preview',
    name: 'Previewer',
    component: ActivityPreview,
    meta: {
      title: 'ActivityPreview'
    }
  },
  {
    path: '/curriculum',
    name: 'Curriculum',
    component: Curriculum,
    meta: {
      title: 'Curriculum',
      middleware: [requiresAuth]
    }
  },
  {
    path: '/activity-trophy',
    name: 'Awards',
    component: awardScreen,
    meta: {
      title: 'Awards',
      middleware: [requiresAuth]
    }
  },
  {
    path: '/spotcheck-result',
    name: 'SpotcheckResults',
    component: spotcheckResult,
    meta: {
      title: 'Spotcheck Results',
      middleware: [requiresAuth]
    }
  },
  {
    path: '/assessment-help',
    name: 'AssessmentHelp',
    component: assessmentHelp,
    meta: {
      title: 'Assessment Help',
      middleware: [requiresAuth]
    }
  }
];
